import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { FC, useState } from "react";
import Select from "shared/components/Form/Select";
import { COLOR_BLACK } from "shared/theme/colors";
import NumberOfTickets from "./components/NumberOfTickets";
import { StyledContainer, StyledSelectContainer } from "./styled";
import { periodOptions } from "./utils";
import AverageResponseTime from "./components/AverageResponseTime";
import SupportQueriesByCategory from "./components/SupportQueriesByCategory";

const DataAnalytics: FC = () => {
  const [period, setPeriod] = useState<string>(periodOptions[0].value);

  return (
    <StyledContainer>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="heading2">Analytics Dashboard</Typography>
        <StyledSelectContainer>
          <Select
            id="period"
            labelColor={COLOR_BLACK}
            placeholder="Select a Period"
            disabledPlaceholder
            fullWidth
            required
            value={period ?? undefined}
            handleChange={setPeriod}
            options={periodOptions}
          />
        </StyledSelectContainer>
      </Box>
      <Box display="flex" gap="1rem">
        <NumberOfTickets />
        <AverageResponseTime />
      </Box>
      <Box display="flex" gap="1rem">
        <SupportQueriesByCategory />
      </Box>
    </StyledContainer>
  );
};

export default DataAnalytics;
